import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import React from 'react';
import MdEmail from 'react-icons/lib/md/email';
import MdPhoneIphone from 'react-icons/lib/md/phone-iphone';
import MdLaptopMac from 'react-icons/lib/md/laptop-mac';
import MdPhone from 'react-icons/lib/md/phone';
import './MarketingOptions.scss';

const isAllSelected = (marketingOptions) => {
  const marketingOptionKeys = Object.keys(marketingOptions);

  return (
    marketingOptionKeys.length === 4 &&
    marketingOptionKeys.reduce((carry, optionKey) => {
      const option = marketingOptions[optionKey];
      return carry && option > 0;
    }, true)
  );
};

const IconMap = {
  post: MdEmail,
  email: MdLaptopMac,
  sms: MdPhoneIphone,
  phone: MdPhone,
};

const Checkbox = ({ inline, width, id, value, isChecked, onChange, label }) => {
  return (
    <div className={'marketing-options--checkbox'}>
      <span>{label}</span>

      <div
        className={'radio-container' + (inline ? ' inline' : '')}
        style={width ? { width: width } : {}}
      >
        <div className="marketing-options--checkbox-input">
          <input
            type="checkbox"
            id={id}
            value={value}
            onChange={onChange}
            checked={isChecked}
          />
          <label htmlFor={id} />
        </div>
        {/*<div className="radio-label" onClick={() => input.onChange(option.value)}>*/}
        <div className="radio-label" />
      </div>
    </div>
  );
};

export const MarketingCheckboxField = ({ input, inline, width, label }) => {
  const handleOnChange = (e) => {
    const isChecked = e.target.checked;
    const result = isChecked ? 1 : -1;
    input.onChange(result);
  };

  return (
    <Checkbox
      inline={inline}
      width={width}
      id={input.name}
      value={input.value}
      isChecked={input.value === 1}
      onChange={handleOnChange}
      label={label}
    />
  );
};
const MarketingOptions = ({ options, inline, incSelectAll, input }) => {
  const handleSelectAll = () => {
    const allSelected = isAllSelected(input.value);
    const newValue = allSelected ? -1 : 1;

    const allOptions = options.reduce((carry, opt) => {
      carry[opt.name] = newValue;
      return carry;
    }, {});

    input.onChange(allOptions);
  };

  return (
    <div className={'marketing-options'}>
      <Row>
        {incSelectAll && (
          <Col sm={3}>
            <Checkbox
              onChange={handleSelectAll}
              id={'select-all'}
              //isChecked={allSelected}
              inline={inline}
              label={
                <div className={'marketing-options--label'}>
                  <span> Select all</span>
                </div>
              }
            />
          </Col>
        )}
        {options.map((option) => {
          const Icon = IconMap[option.name];
          return (
            <Col sm={3}>
              <Field
                name={`${input.name}.${option.name}`}
                component={MarketingCheckboxField}
                labelSize={8}
                label={
                  <div className={'marketing-options--label'}>
                    <Icon size={25} />
                    <span> {option.label}</span>
                  </div>
                }
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
export default MarketingOptions;
